export default __webpack_public_path__ + "dc286491ebb4943686771b125e4d9f0a.png";